import Iframe from "react-iframe";

interface GoogleTagManagerNoScriptProps {
    gtmId: string;
}
const GoogleTagManagerNoScript = ({ gtmId }: GoogleTagManagerNoScriptProps) => {
   return (
       <noscript>
            <Iframe
                url={`//www.googletagmanager.com/ns.html?id=${gtmId}`}
                height="0"
                width="0"
                display="none"
            ></Iframe>
        </noscript>
    );
};
export default GoogleTagManagerNoScript;
